/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import "./OfferslistPage.css";
import no_offers from "./../../../assets/no_offers.svg";
import { Dropdown, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import NodatafoundPage from "../../nodatafound/components/NodatafoundPage";
import { useTranslation } from "react-i18next";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { ADD_OFFER, DELETE_OFFER, OFFER_LIST } from "../../constants/apiurl";
import { postRequestcall } from "../../comman/util/postRequest";
import { getRequestcall } from "../../comman/util/getRequest";
import PaginationPage from "../../comman/components/PaginationPage";
import { clearStoredetail } from "../../dashboard/redux/actions";
import { fetchLogindata } from "../../login/redux/actions";
import moment from "moment";
const DeletepopupPage = React.lazy(() =>
  import("../../modal/components/DeletepopupPage")
);

function OfferslistPage(props) {

  const { access_token } = props;
  const { t } = useTranslation();
  const [offerList, setOfferList] = useState({
    total: 0,
    data: [],
    links: [],
  });
  const [offerempty, setOfferempty] = useState();
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteInfo, setDeleteinfo] = useState({
    title: t("pages.offers.deleteoffer"),
    sub_title: t("pages.offers.deleteoffer_desc"),
    name: "",
    id: "",
    type: t("pages.offers.product"),
  });
  const [storeApprove,setStoreapprove] = useState("");

  useEffect(() => {
    callGetofferList("1");
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    setDeleteinfo({
      ...deleteInfo,
      title: t("pages.offers.deleteoffer"),
      sub_title: t("pages.offers.deleteoffer_desc"),
      name: "",
      id: "",
      type: t("pages.offers.product"),
    });
    props?.fetchHeaderContent(t("pages.sidenav.addoffer"), "", "");
    // eslint-disable-next-line
  }, [props?.language]);

  function LightenDarkenColor(col, amt) {
    var usePound = false;
    if(col == "1F1F1F" || col == "1f1f1f"){
      return "1F1F1F";
    }
    if (col[0] === "#") {
      col = col.slice(1);
      usePound = true;
    }
    var num = parseInt(col, 16);
    var r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if (r < 0) r = 0;
    var b = ((num >> 8) & 0x00ff) + amt;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;
    var g = (num & 0x0000ff) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
  }

  const callGetofferList = async (page) => {
    let responceOffer = await getRequestcall(
      OFFER_LIST + `?page=${page}`,
      access_token
    );
    if (responceOffer?.status === 200) {
      setStoreapprove("");
      const resultOffer = await responceOffer.json();
      if (resultOffer?.data?.data?.length === 0) {
        setOfferempty(true);
      } else {
        setOfferList({
          data: resultOffer?.data?.data,
          links: resultOffer?.data?.links,
          total: resultOffer?.data?.total,
        });
        setOfferempty(false);
      }
    } else if (responceOffer?.status === 400) {
      let getError = await responceOffer.json();
      if (getError?.error?.is_deleted) {
        props?.clearStoredetail([]);
        props.logindata.type = "user";
        props.fetchLogindata(props.logindata);
        navigate("/vendor/");
      } else {
        setOfferempty(true);
        setStoreapprove(getError?.errors);
        toast.error(getError?.errors);
      }
    } else {
        offerListempty();
    }
  };

  const offerListempty = () => {
    setOfferList({
      data: [],
      links: [],
      total: 0,
    });
    setOfferempty(true);
  }

  const onChangeOfferPagination = async (page) => {
    callGetofferList(page);
  };

  const productDelete = (item) => {
    setDeleteinfo({
      ...deleteInfo,
      name: item.title,
      id: item.oid,
    });
    setDeleteModal(true);
  };

  const callDeletOffer = async () => {
    let payload = {
      id: deleteInfo?.id,
    };
    let responceDelete = await postRequestcall(
      DELETE_OFFER,
      access_token,
      payload
    );
    if (responceDelete?.status === 200) {
      callGetofferList();
      toast.success(t("pages.offers.delete_toast"));
      setDeleteModal(false);
    }
  };

  const offershare = (item) => {
    if (item?.type === "percentage") {
      window.open(
        `mailto:?subject=UP TO ${item?.percentage}% OFF&body=${process.env.REACT_APP_BASE_URL}/intent/store/${item?.id}`
      );
    } else {
      window.open(
        `mailto:?subject=UP TO ${item?.flat_discount} OFF&body=${process.env.REACT_APP_BASE_URL}/intent/store/${item?.id}`
      );
    }
  };

  const changeStatus = async (e, item) => {
    const payload = {
      color: item?.color,
      percentage: item?.type === "percentage" ? item?.percentage : null,
      flat_discount: item?.type === "flat" ? item?.flat_discount : null,
      for_online_payment: item?.for_online_payment,
      min_order_amount: item?.min_order_amount,
      end_date: item?.end_date,
      start_date: item?.start_date,
      title: item?.title === "" ? item?.title_in_tr : item?.title,
      title_in_tr: item?.title_in_tr === "" ? item?.title : item?.title_in_tr,
      description_in_tr:
        item?.description_in_tr === ""
          ? item?.description
          : item?.description_in_tr,
      description:
        item?.description === "" ? item?.description_in_tr : item?.description,
      type: item?.type,
      store_id: item?.store_id,
      coupon_code: item?.coupon_code,
      active_status: e.target.checked === true ? "active" : "deactive",
      id: item?.oid,
    };
    let responceAddOfer = await postRequestcall(
      ADD_OFFER,
      access_token,
      payload
    );
    if (responceAddOfer?.status === 200) {
      toast.success(
        `Your ${item?.coupon_code} Offer is ${payload.active_status}`
      );
      let updatedList = [];
      offerList.data.forEach((getItem) => {
        if (getItem.oid === item.oid) {
          getItem.active_status = payload.active_status;
        }
        updatedList.push(getItem);
      });
      setOfferList({
        ...offerList,
        data: updatedList,
      });
    } else if(responceAddOfer.status === 400) {
      props?.clearStoredetail([]);
      props.logindata.type = "user";
      props.fetchLogindata(props.logindata);
      let getError = await responceAddOfer.json();
      toast.error(getError?.errors);
      navigate("/vendor/");
     }
  };

  const addOffer = () => {
    if(storeApprove === "") {
      navigate("add");
    } else {
      toast.error(storeApprove);
    }
  }

  const editOffer = (item) => {
      if(storeApprove === "") {
        navigate(`${item.id}`, {
          state: { item: item },
        })
      }else{
        toast.error(storeApprove);
      }
  }

  return (
    <div className="col-xl-9 main-content offerlist-centent">
      <div className="block-inline mb-4">
        <div className="left-side">
          <h5 className="header-title">{t("pages.offers.title")}</h5>
        </div>
        <div className="right-side align-center">
          <button onClick={() => addOffer()} className="primary-btn ">
            {t("pages.offers.addnewoffer")}
          </button>
        </div>
      </div>
      <Row className="mt-2 mb-3 offers-list-ofproduct">
        {offerempty ? (
          <NodatafoundPage
            className={"col-xl-12 main-content offerlists-centent"}
            image={no_offers}
            button={t("pages.backtodashboard")}
            title={t("pages.offers.nooffers")}
            description={t("pages.offers.nooffers_desc")}
            navigation={"/vendor/dashboard"}
          />
        ) : (
          offerList?.data?.map((item, index) => (
            <div key={index.toString()} className="col-4 mb-3">
              <div className="card" style={{ background: `#${item?.color?.replace("#", "")}` }}>
                <div className="offer_ticket">
                  <div class="offer_ticket_shape">
                    <div class="top"></div>
                    <div class="rip"></div>
                    <div
                      style={{
                        backgroundColor: `#${LightenDarkenColor(
                          item?.color?.replace("#", ""),
                          -40
                        )}`,
                      }}
                      class="bottom"
                    ></div>
                  </div>
                  <div className="offer_ticket_content">
                    <div className="card-body">
                      <div className="action">
                        <label class="switch">
                          <input
                            type="checkbox"
                            checked={
                              item?.active_status === "active" ? true : false
                            }
                            id="active_status"
                            onChange={(e) => changeStatus(e, item)}
                          />
                          <span class="slider round"></span>
                        </label>
                        <div className="action-button">
                          <Dropdown
                            align={"end"}
                            id={"menu-drop"}
                            className={"menu-drop"}
                          >
                            <Dropdown.Toggle
                              variant="success"
                              id="dropdown-basic"
                            >
                                <i className={`common_icon ThreeDots color-${item?.color}`} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="drop-menus">
                              <Dropdown.Item
                                onClick={() =>
                                  editOffer(item)
                                }
                              >
                                {t("pages.offers.edit")}
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  offershare(item);
                                }}
                              >
                                {t("pages.offers.share")}
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  productDelete(item);
                                }}
                              >
                                {t("pages.offers.delete")}
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                      <div className="offer-upto">
                        {item?.type === "percentage"
                          ? props?.language === "Tr"
                            ? `${item?.percentage}% ${t("pages.OFF")}`
                            : `${t("pages.offers.upto")} ${
                                item?.percentage
                              }% ${t("pages.offers.off")}`
                          : `${t("pages.offers.upto")} ${item?.flat_discount}${
                              process.env.REACT_APP_CURRENCY_SYMBOL
                            } ${t("pages.offers.off")} `}
                      </div>
                      <h3>
                        {props?.language === "Tr"
                          ? item?.title_in_tr
                          : item?.title}
                      </h3>
                      <span >
                        {props?.language === "Tr"?(
                          <React.Fragment>
                            <h4 className="d-inline">{`${item?.min_order_amount} ${process.env.REACT_APP_CURRENCY_SYMBOL}`}</h4> {t("pages.add_offer.above")}
                          </React.Fragment>
                        ):(
                          <React.Fragment>
                            {t("pages.add_offer.above")}{" "}
                            <h4 className="d-inline">{`${item?.min_order_amount} ${process.env.REACT_APP_CURRENCY_SYMBOL}`}</h4>
                          </React.Fragment>
                        )}
                      </span>
                      <h4 hidden>
                        {item?.min_order_amount}
                        {process.env.REACT_APP_CURRENCY_SYMBOL}
                      </h4>
                      <p className="date">
                        {t("pages.offers.validtill")}:
                        {moment(item?.end_date).format("DD-MM-YYYY") }
                      </p>
                    </div>
                    <div className="text-center coupon_code">
                      <p
                        title="copy"
                        className="mb-0"
                        id="coupan"
                        onClick={(e) =>
                          navigator.clipboard
                            .writeText(e.target.innerHTML)
                            .then(() => toast.success(t("pages.offers.copy")))
                        }
                      >
                        {item?.coupon_code}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </Row>
      {!offerempty && offerList?.total > 10 && (
        <PaginationPage
          changeCurrentpage={onChangeOfferPagination}
          nopagination={offerempty}
          links={offerList?.links}
        />
      )}
      {deleteModal && (
        <DeletepopupPage
          setDeleteModal={setDeleteModal}
          deleteInfo={deleteInfo}
          deleteModal={deleteModal}
          itemDelete={callDeletOffer}
        ></DeletepopupPage>
      )}
    </div>
  );
}
const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  logindata: state?.login?.logindata,
  storeDetail: state?.dashboard?.storeDetail,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, { fetchHeaderContent,clearStoredetail,fetchLogindata })(OfferslistPage);
